export default function getDashboardReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_DASHBOARD_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_DASHBOARD_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_DASHBOARD_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}